import { render, staticRenderFns } from "./StoreNotes.vue?vue&type=template&id=a8eef55e"
import script from "./StoreNotes.vue?vue&type=script&lang=ts"
export * from "./StoreNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports